<div id="mu-menu-top-bar" class="mu-flex" [ngClass]="{ 'mu-menu-top-bar-off': showSignIn }">
  <div class="mu-menu-top-bar-icon-menu mu-inline-flex">
    <i class="mu-icon mu-icon-menu" aria-hidden="true" (click)="actionList?.emit(actionListEnum.SHOW_MENU, null)"></i>
  </div>
  <div class="mu-menu-top-bar-icon-logo mu-inline-flex">
    <img src="assets/images/logos/logo-h-mu.svg" alt="" [routerLink]="redirectLink" />
  </div>
  <div class="mu-menu-top-bar-data mu-inline-flex">
    <div class="mu-menu-top-bar-data-name">{{ userData?.name }}</div>
    <div class="mu-menu-top-bar-data-company" *ngIf="userData?.companyName">{{ userData?.companyName }}</div>
  </div>
  <div class="mu-menu-top-bar-icon-account mu-inline-flex">
    <img src="assets/images/icons/account-type/icon-account-type-{{ accountTypeIcon }}.svg" alt="" />
  </div>
  <div class="mu-menu-top-bar-arrow mu-inline-flex" #topbarmenu>
    <i class="mu-icon mu-icon-arrow-up" aria-hidden="true" (click)="toggleMenu()"></i>
    <app-topbar-menu
      id="topbar-menu"
      class="mu-menu-top-bar-sub-menu"
      [ngClass]="{ 'mu-menu-top-bar-sub-menu-show': showMenu }"
      [loginActionsMenu]="loginActionsMenu"
      [layoutTopbarMenuList]="layoutTopbarMenuList"
    >
    </app-topbar-menu>
  </div>
  <div *ngIf="showSignIn" class="mu-menu-top-bar-sign-in mu-menu-inline-flex">
    <button
      routerLink="/crear-cuenta"
      pButton
      type="button"
      [label]="'page.login.register.3' | translate"
      class="p-button-text mu-button-text"
    ></button>
    <p-button
      muButtonLeft
      [label]="'page.login.tabs.login' | translate"
      class="mu-btnlogin mu-button mu-button-outline"
      type="button"
      (onClick)="expressFlagList?.enable(expressFlagListEnum.SHOW_MODAL_LOGIN)"
    >
    </p-button>
  </div>
</div>

<app-mu-modal-login [flagList]="expressFlagList" [showFlag]="expressFlagListEnum.SHOW_MODAL_LOGIN" [loginActions]="loginActions">
</app-mu-modal-login>
